// GLOBAL
export const ERROR = "ERROR"
export const FORM_ERRORS = "FORM_ERRORS"

// User Types
export const LOGIN_USER = "LOGIN_USER"
export const LOGOUT_USER = "LOGOUT_USER"
export const USER_TABLES = "USER_TABLES"
export const USER_TABLE_CUPPINGS = "USER_TABLE_CUPPINGS"
export const ANOTHER_USER = "ANOTHER_USER"
export const UPDATE_USER = "UPDATE_USER"
export const DELETE_USER = "DELETE_USER"

// Cupping / Table Types
export const NEW_TABLE = "NEW_TABLE"
export const SINGLE_TABLE = "SINGLE_TABLE"
export const SINGLE_CUPPING = "SINGLE_CUPPING"
export const LATEST_CUPPINGS = "LATEST_CUPPINGS"
export const UPDATE_TABLE = "UPDATE_TABLE"
export const UPDATE_CUPPING = "UPDATE_CUPPING"
export const DELETE_TABLE = "DELETE_TABLE"
export const DELETE_CUPPING = "DELETE_CUPPING"